export const addCustomer = async (customerData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({ action: "addCustomers", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, ...customerData })
    });
    const jsonResponse = await response.json();

    if (jsonResponse?.success === true) {
        let data = customerData;
        data.id = jsonResponse?.data?.id;
        
        jsonResponse.data = data;
        console.log('Raw contact from response:', jsonResponse.data);
        const contactStr = Number(jsonResponse?.data?.contact?.toString());
        console.log('Formatted contact number:', contactStr);
        data.contact = contactStr;
    }
    console.log('Add Customer Response:', jsonResponse);
    return jsonResponse;
};
export const updateCustomer = async (customerId, customerData) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({ action: "updateCustomers", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: customerId, ...customerData })
    });
    const jsonResponse = await response.json();
    if (jsonResponse?.success === true) {
        let data = customerData;
        data.id = customerId;
        jsonResponse.data = data;
        const contactStr = Number(jsonResponse?.data?.contact?.toString());
        console.log('Formatted contact number after update:', contactStr);
        data.contact = contactStr;
    }
    console.log('Update Customer Response:', response);
    return jsonResponse;
};
export const deleteCustomer = async (customerId) => {
    const response = await fetch(process.env.REACT_APP_API_URL, {
        method: "POST",
        body: JSON.stringify({ action: "deleteCustomers", apiKey: process.env.REACT_APP_API_KEY, origin: window.location.origin, id: customerId })
    });
    return await response.json();
};
